import { render, staticRenderFns } from "./Allcontacts.vue?vue&type=template&id=d6209ece&scoped=true&"
import script from "./Allcontacts.vue?vue&type=script&lang=js&"
export * from "./Allcontacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6209ece",
  null
  
)

export default component.exports